import { render, staticRenderFns } from "./add-bank-dialog.vue?vue&type=template&id=3ba825b2&scoped=true"
import script from "./add-bank-dialog.vue?vue&type=script&lang=js"
export * from "./add-bank-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-bank-dialog.vue?vue&type=style&index=0&id=3ba825b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba825b2",
  null
  
)

export default component.exports